export default {
  'bindTo': 'this',
  'method': function(){
    alert('Registro Iva')
  },
}
